import styled from 'styled-components';
import constants from '../../../abstracts/constants';
import colours from '../../../abstracts/colours';

interface BadgeProps {
  done: boolean;
}

export const StyledBadgeContainer = styled.div`
  font-size: ${constants.LARGE};
  font-family: ${constants.sourceSansPro};
  display: inline-block;
  text-align: center;
  line-height: 1.5;
  width: 72px;
  height: 72px;
`;

export const StyledLabel = styled.div`
  color: ${colours.greyishBrown};
  font-size: ${constants.MEDIUM};
  width: 72px;
  display: inline-block;
`;

export const StyledBadge = styled.div<BadgeProps>`
  background-color: ${(props) => (props.done ? colours.weirdGreen : colours.black)};
  color: ${(props) => (props.done ? colours.black : colours.alabaster)};
  border-radius: 8px;
  width: 64px;
  height: 32px;
  padding: 8px 0px 8px 0px;
  display: inline-block;
  box-sizing: content-box;
`;
